import { api } from './auth.service';

const clienteService = {

  listar: async () => {
    const res = await api.get('/clientes');
    return res.data;
  },

  // r167b: versão LEVE pra combos. Bate em /clientes/referencia, que é liberado
  // a QUALQUER usuário autenticado (não exige permissão de Clientes). Use esta
  // em formulários onde o usuário só precisa ESCOLHER um cliente — não gerenciar
  // o cadastro (ex.: modal de lançamento de horas, modal de tarefa).
  //   clienteService.listarReferencia()          → todos os ativos
  //   clienteService.listarReferencia('petro')   → autocomplete por texto
  listarReferencia: async (q) => {
    const res = await api.get('/clientes/referencia', { params: q ? { q } : {} });
    return res.data;
  },

  buscarPorId: async (id) => {
    const res = await api.get(`/clientes/${id}`);
    return res.data;
  },

  incluir: async (dados) => {
    const res = await api.post('/clientes', dados);
    return res.data;
  },

  alterar: async (id, dados) => {
    const res = await api.put(`/clientes/${id}`, dados);
    return res.data;
  },

  alterarStatus: async (id, status) => {
    const res = await api.patch(`/clientes/${id}/status`, { status });
    return res.data;
  },
};

export default clienteService;
